module.exports = __webpack_public_path__ + "static/media/external-link.11e47af9.svg";